import { useEffect, useState } from "react";
import { Loader2, Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function RenameRouteDialog({ route, count, onClose, onRenamed }) {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setName(route || ""); }, [route]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/route-setup/rename", { old: route, new: name.trim() });
      toast.success(`Route ${route} renamed to ${data.route} on ${data.updated} customer${data.updated === 1 ? "" : "s"}`);
      onRenamed(data.route);
    } catch (err) { toast.error(formatError(err)); }
    setBusy(false);
  };

  return (
    <Dialog open={!!route} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-card" data-testid="rename-route-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Rename route {route}</DialogTitle>
          <DialogDescription>Changes the route on all {count} customers of {route} in your main database.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="rename-route-input">New route name</Label>
            <Input id="rename-route-input" value={name} onChange={(e) => setName(e.target.value)} maxLength={100} required className="font-mono" data-testid="rename-route-input" />
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={onClose} data-testid="rename-route-cancel">Cancel</Button>
            <Button type="submit" disabled={busy || !name.trim() || name.trim() === route} data-testid="rename-route-save">
              {busy ? <Loader2 size={15} className="animate-spin" /> : <Pencil size={15} />} Rename
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
